import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
export function CountdownBar() {
  // 14 minutes and 10 seconds = 850 seconds
  const [timeLeft, setTimeLeft] = useState(850);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white py-1.5 px-4 shadow-md" data-id="element-35">
      <div className="max-w-3xl mx-auto flex items-center justify-center gap-2 md:gap-4 text-xs md:text-sm font-bold text-center" data-id="element-36">
        <div className="flex items-center gap-1 text-yellow-300" data-id="element-37">
          <ClockIcon className="w-4 h-4" data-id="element-38" />
          <span className="hidden md:inline" data-id="element-39">OFERTA EXPIRA EN:</span>
        </div>
        <div className="text-lg md:text-xl font-black tracking-wider text-white" data-id="element-40">
          00:{minutes.toString().padStart(2, '0')}:
          {seconds.toString().padStart(2, '0')}
        </div>
        <div className="border border-white/50 text-white px-2 py-0.5 rounded text-[10px] md:text-xs" data-id="element-41">
          SOLO QUEDAN 3 CUPOS
        </div>
      </div>
    </div>;
}